import { SelectionModel } from '@angular/cdk/collections';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource, MatDialog, MatSnackBar } from '@angular/material';
import { environment } from 'environments/environment';
import Swal from 'sweetalert2';
import { Plano } from '../../shared/models/plano.model';
import { ViewModelDadosInstitutos } from '../../shared/models/ViewModelDadosInstitutos.model';
import { ViewModelDadosModulos } from '../../shared/models/ViewModelDadosModulos.model';
import { ViewModelFiltroWebModulosTextos } from '../../shared/models/viewModelFiltroWebModulosTextos.model';
import { ViewModelProcessoWebModulosTextos } from '../../shared/models/ViewModelProcessoWebModulosTextos.model';
import { WebModulosTextos } from '../../shared/models/webModulosTextos.model';
import { PlanoService } from '../../shared/services/plano.service';
import { WebModulosTextosService } from '../../shared/services/webModulosTextos.service';
import { LoginStore } from '../../shared/store/login.store';
import { ModalMensagemComponent } from '../cadastrar-mensagem-modulo/modal-mensagem/modal-mensagem/modal-mensagem.component';
import { WebIntegrFuncionalidade } from '../../shared/models/webIntegrFuncionalidade.model';
import { PlanoCategoria } from '../../shared/models/planoCategoria.model';
import { WebBloqueioExcecaoService } from '../../shared/services/webBloqueioExcecao.service';
import { ViewModelFiltroWebBloqueioExcecao } from '../../shared/models/ViewModelFiltroWebBloqueioExcecao.model';
import { ViewModelProcessoWebBloqueioExcecao } from '../../shared/models/ViewModelProcessoWebBloqueioExcecao.model';
import { ModalCadastroExcecaoComponent } from './modal-cadastro-excecao/modal-cadastro-excecao.component';




export interface Food {
  value: string;
  viewValue: string;
}
@Component({
  selector: 'app-mensagem-excecao',
  templateUrl: './mensagem-excecao.component.html',
  styleUrls: ['./mensagem-excecao.component.scss']
})
export class MensagemExcecaoComponent implements OnInit {
  [x: string]: any;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  webModulosTextos: WebModulosTextos = new WebModulosTextos();
  lista_Modulo: ViewModelDadosModulos[] = [];
  lista_Instituto: ViewModelDadosInstitutos[] = [];
  lista_Plano: Plano[] = [];
  displayedColumns: string[] = ['nmModulos', 'nmPlano', 'nmCategoria', 'situacao', 'Matricula', 'nmTexto', 'alterar', 'excluir'];
  selection = new SelectionModel<any>(true, []);
  dataSource = new MatTableDataSource<any>();
  loading = false;
  selectedModulo: number;
  selectedPlano: number;
  selectedInstituto: number;
  dataInicio: string;
  dataFim: string;
  idPessoaLogada: number;
  ListaIdPessoa: number[];
  isDateFormat: boolean = environment.isDateFormat;
  viewModelFiltroWebModulosTextos: ViewModelFiltroWebModulosTextos = new ViewModelFiltroWebModulosTextos();
  viewModelProcessoWebModulosTextos: ViewModelProcessoWebModulosTextos = new ViewModelProcessoWebModulosTextos();
  viewModelProcessoWebBloqueioExcecao: ViewModelProcessoWebBloqueioExcecao = new ViewModelProcessoWebBloqueioExcecao();
  viewModelFiltroWebBloqueioExcecao: ViewModelFiltroWebBloqueioExcecao = new ViewModelFiltroWebBloqueioExcecao();
  nmTexto: string = '';
  lista_Funcionalidades: WebIntegrFuncionalidade[] = [];
  selectedFuncionalidade: number;
  lista_Categoria: PlanoCategoria[] = [];
  selectedCategoria: number;

  nrCpf: string;
  constructor(
    private planoService: PlanoService,
    private webModulosTextosService: WebModulosTextosService,
    private loginStore: LoginStore,
    private dialog: MatDialog,
    private _snackBar: MatSnackBar,
    private webBloqueioExcecaoService: WebBloqueioExcecaoService,
  ) {

  }

  ngOnInit() {
    this.loginStore.getCurrent().subscribe(retorno => {
      this.idPessoaLogada = retorno.idPessoa;
    });

    this.dataSource.paginator = this.paginator;

    this.loadPlano();
    this.preencheTabela();
    this.loadFuncionalidades();
    this.loadCategorias();



  }

  openModal(viewModelProcessoWebModulosTextos: ViewModelProcessoWebModulosTextos | null) {

    const dialogRef = this.dialog.open(ModalCadastroExcecaoComponent, {
      width: "60vw",
      height: "70vh",
      maxWidth: "1700px",
      maxHeight: "600px",
      data: {
        funcionalidades: this.lista_Funcionalidades,
        planos: this.lista_Plano,
        categorias: this.lista_Categoria
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'sucesso') {
        this.preencheTabela();
      }
    });
  }
  loadPlano() {
    this.webBloqueioExcecaoService.retornaListaComboPlanos().subscribe(plano => {
      this.lista_Plano = plano
        .filter(p => p.idPlano !== 0)
        .sort((a, b) => a.idPlano - b.idPlano);
    });
  }
  loadFuncionalidades() {
    this.webBloqueioExcecaoService.retornaListaComboFuncionalidades()
      .subscribe((res) => {
        this.lista_Funcionalidades = res.sort((a, b) => a.idFuncionalidade - b.idFuncionalidade);
      }, error => {
        console.error('Erro ao carregar funcionalidades', error);
      });
  }
  loadCategorias() {
    this.webBloqueioExcecaoService.retornaListaComboCategorias()
      .subscribe((res) => {
        this.lista_Categoria = res.sort((a, b) => a.idCategoria - b.idCategoria);;

      }, error => {
        console.error('Erro ao carregar categorias', error);
      });
  }
openModal2(element) {
  const dialogRef = this.dialog.open(ModalCadastroExcecaoComponent, {
    width: "90vw",
    height: "80vh",
    maxWidth: "1200px",
    maxHeight: "600px",
    data: {
      modo: 'editar',
      objeto: element // 👈 manda direto
    }
  });

  dialogRef.afterClosed().subscribe(result => {
    if (result === 'sucesso') {
      this.preencheTabela();
    }
  });
}



  onModuloChange() {
    this.updateInstitutos();
  }

  onPlanoChange() {
    this.updateInstitutos();
  }

  updateInstitutos() {
    const modulo = this.selectedModulo || 0;
    const plano = this.selectedPlano || 0;

    this.loadInstitutoPorModuloEPlano(modulo, plano);
    this.selectedInstituto = null;

  }



  loadInstitutoPorModuloEPlano(idModulo: number, idPlano: number) {
    this.webModulosTextosService.RetornaListaFiltroInstitudo(idModulo, idPlano).subscribe(
      (institutos) => {
        this.lista_Instituto_Modulo = institutos;
      },
      (error) => {
        this.list_Instituto_Modulo = [...this.lista_Instituto]
      }
    );
  }

  excluir(idSeq: number) {
    Swal.fire({
      title: 'Confirmar exclusão',
      text: 'Você tem certeza que deseja excluir este registro?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Sim, excluir',
      cancelButtonText: 'Cancelar',
      width: '500px',
      padding: '1.3rem',
      customClass: {
        popup: 'modal-alerta'
      }
    }).then((result) => {

      if (!result.isConfirmed) {
        return;
      }

      this.loading = true;

      this.webBloqueioExcecaoService.excluir(idSeq).subscribe(
        retorno => {
          this.loading = false;
          this.openSnackBar('Registro excluído com sucesso', "X");
          this.preencheTabela();
        },
        error => {
          this.loading = false;
          this.openSnackBarError('Erro ao excluir o registro', "X");
        }
      );
    });

  }



  loadModulo() {
    this.webModulosTextosService.RetornaListaComboModulos().subscribe(modulo => {
      this.lista_Modulo = modulo.sort((a, b) => a.idModulos - b.idModulos);
    });
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }


  // /** Selects all rows if they are not all selected; otherwise clear selection. */
  // masterToggle() {
  //     this.isAllSelected() ?
  //         this.selection.clear() :
  //         this.dataSource.data.forEach(row => this.selection.select(row));
  // }


  clear() {
    this.selectedFuncionalidade = undefined;
    this.selectedCategoria = undefined;
    this.selectedPlano = undefined;
  }
  preencheTabela() {
    this.loading = true;


    this.viewModelFiltroWebBloqueioExcecao.idPlano = this.selectedPlano || 0;
    this.viewModelFiltroWebBloqueioExcecao.idFuncionalidade = this.selectedFuncionalidade
    this.viewModelFiltroWebBloqueioExcecao.idPlanoCategoria = this.selectedCategoria

    this.webBloqueioExcecaoService
      .postFiltroBloqueioExcecao(this.viewModelFiltroWebBloqueioExcecao)
      .subscribe(
        (tabela) => {
          // 🔥 agora a API já retorna array direto
          this.dataSource = new MatTableDataSource<ViewModelProcessoWebBloqueioExcecao>(tabela);
          this.dataSource.paginator = this.paginator;

          this.loading = false;
        },

      );
  }








  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 20000,
      panelClass: ['mat-toolbar', 'mat-success']
    });
  }

  openSnackBarError(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 20000,
      panelClass: ['mat-toolbar', 'mat-warn']
    });
  }

}



